var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicrosoft365 = function SvgMicrosoft365(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "4 2 40 44"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#microsoft365_svg__a)",
    d: "m20.084 3.026-.224.136a8 8 0 0 0-1.009.722l.648-.456H25L26 11l-5 5-5 3.475v4.008a8 8 0 0 0 3.857 6.844l5.264 3.186L14 40h-2.145l-3.998-2.42A8 8 0 0 1 4 30.737V17.26a8 8 0 0 1 3.86-6.846l12-7.258q.111-.068.224-.131"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#microsoft365_svg__b)",
    d: "m20.084 3.026-.224.136a8 8 0 0 0-1.009.722l.648-.456H25L26 11l-5 5-5 3.475v4.008a8 8 0 0 0 3.857 6.844l5.264 3.186L14 40h-2.145l-3.998-2.42A8 8 0 0 1 4 30.737V17.26a8 8 0 0 1 3.86-6.846l12-7.258q.111-.068.224-.131"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#microsoft365_svg__c)",
    d: "M32 19v4.48a8 8 0 0 1-3.857 6.844l-12 7.264a8 8 0 0 1-8.007.16l11.721 7.096a8 8 0 0 0 8.286 0l12-7.264A8 8 0 0 0 44 30.736V27.5L43 26z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#microsoft365_svg__d)",
    d: "M32 19v4.48a8 8 0 0 1-3.857 6.844l-12 7.264a8 8 0 0 1-8.007.16l11.721 7.096a8 8 0 0 0 8.286 0l12-7.264A8 8 0 0 0 44 30.736V27.5L43 26z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#microsoft365_svg__e)",
    d: "m40.14 10.415-12-7.258a8 8 0 0 0-8.042-.139l-.238.144A8 8 0 0 0 16 10.008v9.483l3.86-2.334a8 8 0 0 1 8.28 0l12 7.258A8 8 0 0 1 43.997 31q.004-.132.004-.263V17.261a8 8 0 0 0-3.86-6.846"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#microsoft365_svg__f)",
    d: "m40.14 10.415-12-7.258a8 8 0 0 0-8.042-.139l-.238.144A8 8 0 0 0 16 10.008v9.483l3.86-2.334a8 8 0 0 1 8.28 0l12 7.258A8 8 0 0 1 43.997 31q.004-.132.004-.263V17.261a8 8 0 0 0-3.86-6.846"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#microsoft365_svg__g)",
    d: "M4.004 30.998"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#microsoft365_svg__h)",
    d: "M4.004 30.998"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "microsoft365_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(110.528 5.021 11.358)scale(33.3657 58.1966)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.064,
    stopColor: "#AE7FE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078D4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "microsoft365_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(30.7198 -4.51832 2.98465 20.29248 10.43 36.351)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.134,
    stopColor: "#D59DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E438F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "microsoft365_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-24.1583 -6.12555 10.3118 -40.66824 41.055 26.504)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.058,
    stopColor: "#50E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#436DCD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "microsoft365_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-24.1583 -6.12555 10.3118 -40.66824 41.055 26.504)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.058,
    stopColor: "#50E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#436DCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "microsoft365_svg__b",
    x1: 17.512,
    x2: 12.751,
    y1: 37.868,
    y2: 29.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#114A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078D4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "microsoft365_svg__d",
    x1: 40.357,
    x2: 35.255,
    y1: 25.377,
    y2: 32.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#493474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C66BA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "microsoft365_svg__f",
    x1: 16.976,
    x2: 24.487,
    y1: 3.057,
    y2: 3.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2D3F80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#436DCD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "microsoft365_svg__h",
    x1: 16.976,
    x2: 24.487,
    y1: 3.057,
    y2: 3.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2D3F80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#436DCD",
    stopOpacity: 0
  })))));
};
export default SvgMicrosoft365;